import { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../redux/reducer/loginReducer";
import TituloPagina from "../../../components/Titulos/TituloPagina";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Link,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { cmi_cuestionario_satisfaccion } from "../../../services/alumnos";

import Masonry from 'react-masonry-css';
import './masonry.css'; // Necesitarás crear este archivo


import { Bar, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);


/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function SatisfaccionContent() {
  const classes = useStyles();

  const [loadingMotivacion, setLoadingMotivacion] = useState(false);
  const [loadingRelacionTutor, setLoadingRelacionTutor] = useState(false);
  const [loadingValoracionMaterial, setLoadingValoracionMaterial] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");
  const [datosGraficas, setDatosGraficas] = useState({
    motivacion: [],
    relacion_tutor: [],
    valoracion_material: []
  });
  const [comentarios, setComentarios] = useState([]);
  const [mediaTutores, setMediaTutores] = useState(null);

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  const transformarDatos = (resultado) => {
        const dataArray = new Array(10).fill(0);
        if (Array.isArray(resultado)) {
          resultado.forEach(item => {
            const nivel = parseInt(item.nivel);
            if (nivel >= 1 && nivel <= 10) {
              dataArray[nivel - 1] = parseInt(item.total);
            }
          });
        }
        return dataArray;
      };

  const fetchDatos = async () => {
      setLoadingMotivacion(true);
      setLoadingRelacionTutor(true);
      setLoadingValoracionMaterial(true);
      setLoadingMensaje("Cargando estadísticas...");

      // Motivación
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "motivacion"}).then((respuesta) => {

        setLoadingMotivacion(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          motivacion: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Relación con el tutor
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "relacion_tutor"}).then((respuesta) => {

        setLoadingRelacionTutor(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          relacion_tutor: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Valoración del material
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "valoracion_material"}).then((respuesta) => {

        setLoadingValoracionMaterial(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          valoracion_material: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Comentarios
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "comentarios"}).then((respuesta) => {

        setComentarios(respuesta.resultado);

      });
      
      // Media tutores
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "media_tutores"}).then((respuesta) => {

        setMediaTutores(respuesta.resultado);

      });


      
  }

  useEffect(() => {
    fetchDatos();
  }, [usuarioSeleccionado]);


  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */

  const RenderGrafica = ({ titulo, dataValues }) => {
    const totalRespuestas = dataValues.reduce((a, b) => a + b, 0);

    const media = totalRespuestas > 0 
      ? dataValues.reduce((acc, value, index) => acc + (value * (index + 1)), 0) / totalRespuestas
      : 0;

    const data = {
      labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      datasets: [
        {
          data: dataValues,
          backgroundColor: "#6C2DF0",
          borderRadius: 4,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 30, // Añade espacio extra en la parte superior del canvas
        },
      },
      plugins: {
        legend: { display: false },
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 4,
          clip: false, // Evita que la etiqueta se corte si sale del área de dibujo
          formatter: (value) => {
            if (value === 0) return "";
            const percentage = totalRespuestas > 0 ? ((value / totalRespuestas) * 100).toFixed(1) : 0;
            return `${value} (${percentage} %)`;
          },
          font: { weight: "bold", size: 11 },
          color: "#444",
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          grace: '15%', // Añade un 15% de espacio extra sobre el valor máximo automáticamente
          grid: { drawBorder: false },
        },
        x: {
          grid: { display: false },
        },
      },
    };

    return (
      <Grid item xs={12} md={6} lg={4}>
        <Card style={{ marginBottom: 20 }}>
          <CardContent>
            <Typography variant="subtitle1" style={{ fontWeight: 'bold', minHeight: 60 }}>
              {titulo}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {totalRespuestas} respuestas
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{color: "#6C2DF0"}}>
              Media: {media.toFixed(1)}
            </Typography>
            <Box style={{ height: 300, marginTop: 20 }}>
              <Bar data={data} options={options} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const MediaTutores = () => {
    
    if (!mediaTutores || mediaTutores.length === 0) return null;

    return (
      <TableContainer component={Paper} elevation={0} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}></TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Valoraciones</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Motivación</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Tutorización</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Materiales</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mediaTutores.map((tutor, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row" style={{ fontWeight: 'bold' }}>
                  {tutor.tutor_nombre}
                </TableCell>
                <TableCell align="center">
                  {tutor.total_alumnos}
                </TableCell>
                <TableCell align="center">
                  {tutor.motivacion ? parseFloat(tutor.motivacion).toFixed(1) : "-"}
                </TableCell>
                <TableCell align="center">
                  {tutor.relacion_tutor ? parseFloat(tutor.relacion_tutor).toFixed(1) : "-"}
                </TableCell>
                <TableCell align="center">
                  {tutor.valoracion_material ? parseFloat(tutor.valoracion_material).toFixed(1) : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const GraficaMediasTutores = () => {
    if (!mediaTutores || mediaTutores.length === 0) return null;

    const labels = mediaTutores.map((t) => t.tutor_nombre);
    const data = {
      labels,
      datasets: [
        {
          label: "Motivación",
          data: mediaTutores.map((t) => parseFloat(t.motivacion || 0)),
          backgroundColor: "#ECB3D0",
          borderRadius: 4,
        },
        {
          label: "Tutorización",
          data: mediaTutores.map((t) => parseFloat(t.relacion_tutor || 0)),
          backgroundColor: "#6C2DF0",
          borderRadius: 4,
        },
        {
          label: "Materiales",
          data: mediaTutores.map((t) => parseFloat(t.valoracion_material || 0)),
          backgroundColor: "#60DDD1",
          borderRadius: 4,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true, position: "bottom" },
        datalabels: {
          anchor: "end",
          align: "top",
          formatter: (value) => (value > 0 ? value.toFixed(1) : ""),
          font: { weight: "bold", size: 10 },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          max: 10,
          grid: { drawBorder: false },
        },
        x: {
          grid: { display: false },
        },
      },
    };

    return (
      <Card style={{ marginBottom: 20 }}>
        <CardContent>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Comparativa de Medias por Tutor
          </Typography>
          <Box style={{ height: 400, marginTop: 20 }}>
            <Bar data={data} options={options} />
          </Box>
        </CardContent>
      </Card>
    );
  };

  // ...existing code...
  const GraficaRadarTutores = () => {
    if (!mediaTutores || mediaTutores.length === 0) return null;

    const colores = [
      { bg: 'rgba(108, 45, 240, 0.2)', border: '#6C2DF0' },
      { bg: 'rgba(156, 39, 176, 0.2)', border: '#9c27b0' },
      { bg: 'rgba(0, 188, 212, 0.2)', border: '#00bcd4' },
      { bg: 'rgba(76, 175, 80, 0.2)', border: '#4caf50' },
      { bg: 'rgba(255, 152, 0, 0.2)', border: '#ff9800' },
    ];

    const data = {
      labels: ['Motivación', 'Tutorización', 'Materiales'],
      datasets: mediaTutores && mediaTutores.map((tutor, index) => ({
        label: tutor.tutor_nombre,
        data: [
          parseFloat(tutor.motivacion || 0),
          parseFloat(tutor.relacion_tutor || 0),
          parseFloat(tutor.valoracion_material || 0),
        ],
        backgroundColor: colores[index % colores.length].bg,
        borderColor: colores[index % colores.length].border,
        borderWidth: 2,
        pointBackgroundColor: colores[index % colores.length].border,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: colores[index % colores.length].border,
      })),
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
        },
        datalabels: {
          display: false,
        },
      },
      scales: {
        r: {
          beginAtZero: true,
          max: 10,
          ticks: {
            stepSize: 2,
          },
        },
      },
    };

    return (
      <Card style={{ marginBottom: 20 }}>
        <CardContent>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Comparativa General por Tutor
          </Typography>
          <Box style={{ height: 400, marginTop: 20 }}>
            <Radar data={data} options={options} />
          </Box>
        </CardContent>
      </Card>
    );
  };

  const GraficaComparativaTutores = () => {
    if (!mediaTutores || mediaTutores.length === 0) return null;

    const colores = ['#6C2DF0', '#9c27b0', '#00bcd4', '#4caf50', '#ff9800', '#f44336', '#3f51b5'];

    // Gráfica de Motivación
    const dataMotivacion = {
      labels: mediaTutores.map(t => t.tutor_nombre),
      datasets: [{
        label: 'Motivación',
        data: mediaTutores.map(t => parseFloat(t.motivacion || 0)),
        backgroundColor: colores.slice(0, mediaTutores.length),
        borderRadius: 4,
      }]
    };

    // Gráfica de Tutorización
    const dataTutorizacion = {
      labels: mediaTutores.map(t => t.tutor_nombre),
      datasets: [{
        label: 'Tutorización',
        data: mediaTutores.map(t => parseFloat(t.relacion_tutor || 0)),
        backgroundColor: colores.slice(0, mediaTutores.length),
        borderRadius: 4,
      }]
    };

    // Gráfica de Materiales
    const dataMateriales = {
      labels: mediaTutores.map(t => t.tutor_nombre),
      datasets: [{
        label: 'Materiales',
        data: mediaTutores.map(t => parseFloat(t.valoracion_material || 0)),
        backgroundColor: colores.slice(0, mediaTutores.length),
        borderRadius: 4,
      }]
    };

    const options = {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        datalabels: {
          anchor: 'end',
          align: 'right',
          formatter: (value) => value.toFixed(1),
          font: { weight: 'bold', size: 11 },
          color: '#444',
        },
      },
      scales: {
        x: {
          beginAtZero: true,
          max: 10,
          grid: { drawBorder: false },
        },
        y: {
          grid: { display: false },
        },
      },
    };

    return (
      <>
        <Grid item xs={12} md={12}>
          <Card style={{ marginBottom: 20 }}>
            <CardContent>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                Motivación
              </Typography>
              <Box style={{ height: 250 }}>
                <Bar data={dataMotivacion} options={options} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={12}>
          <Card style={{ marginBottom: 20 }}>
            <CardContent>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                Tutorización
              </Typography>
              <Box style={{ height: 250 }}>
                <Bar data={dataTutorizacion} options={options} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={12}>
          <Card style={{ marginBottom: 20 }}>
            <CardContent>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                Materiales
              </Typography>
              <Box style={{ height: 250 }}>
                <Bar data={dataMateriales} options={options} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </>
    );
  };

// ...existing code...
  const Contenido = () => {
    // Datos de ejemplo basados en tu imagen

    return (
      <>
        <TituloPagina titulo={"Cuestionario de Satisfacción"} />

        <Box display="flex" justifyContent="" style={{ padding: "0 20px" }}>
          <Link
            href="https://gestion.innovatiio.com/api/v1/alumno/exportar_cmi_cuestionario_satisfaccion"
            target="_blank"
            className={classes.enlace}
            style={{ fontWeight: "bold" }}
          >
            Exportar CSV
          </Link>
        </Box>

        <Grid style={{ marginTop: 45, padding: "0 15px" }}>
          <Grid container spacing={3}>
            <RenderGrafica 
              titulo="¿Cómo estás de motivado/a en este momento de cara a la oposición?" 
              dataValues={datosGraficas.motivacion} 
            />
            <RenderGrafica 
              titulo="Valoración de la relación con tu tutor/a" 
              dataValues={datosGraficas.relacion_tutor} 
            />
            <RenderGrafica 
              titulo="Valoración del material de estudio" 
              dataValues={datosGraficas.valoracion_material} 
            />
          </Grid>

          <Box style={{ marginTop: 40 }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 20 }}>
              Medias por tutor
            </Typography>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} lg={6}>
                <GraficaComparativaTutores />
              </Grid> */}
              <Grid item xs={12} lg={6}>
                <GraficaMediasTutores />
              </Grid>
              <Grid item xs={6}>
                <MediaTutores />
              </Grid>
            </Grid>
          </Box>
         
          <Box style={{ marginTop: 40 }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 20 }}>
              Comentarios adicionales
            </Typography>
            {comentarios && comentarios.length === 0 ? (
              <Typography variant="body2" color="textSecondary">
                No hay comentarios disponibles.
              </Typography>
            ) : (
              <Masonry
                breakpointCols={{ default: 2, 960: 1 }}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {comentarios && comentarios.map((comentario, index) => (
                  <Paper key={index} elevation={1}>
                    <Box p={2}>
                      <Typography variant="body1" style={{ marginBottom: 12 }}>
                        {comentario.comentario}
                      </Typography>
                      <Link 
                        href={`/alumnos/detalle/${comentario.alumno_id}`} 
                        style={{ textDecoration: 'none' }}
                      >
                        <Typography 
                          variant="body2" 
                          style={{ fontWeight: 'bold', color: "#666", marginTop: 8 }}
                        >
                          {comentario.alumno_nombre}
                        </Typography>
                      </Link>
                      <Typography 
                        variant="body2" 
                        style={{ marginTop: 4, color: "#999" }}
                      >
                        Tutor: {comentario.tutor_nombre}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Masonry>
            )}
          </Box>
        </Grid>
      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
        <Contenido />
    </div>
  );
}

